import styled from "@emotion/styled";
import {  Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { InfoCircleOutlined } from "@ant-design/icons";

import React, { FC } from "react";

interface ProductSGInviteSaleProps {
  is_active: boolean;
}

const ProductSGInviteSale: FC<ProductSGInviteSaleProps> = ({ is_active }) => {
  return (
 
    <FormWrapper>
      <Form.Item
        label="แผนสร้างการซื้อซ้ำ (Repeat Plan)"
        name="sg_invite_sale"
        //rules={[{ required: is_active, message: "กรุณากรอกเชิญชวนเซลล์ชุมชนมาร่วมขายสินค้า" }]}
        tooltip={{
          title: <TooltipContent />,
          icon: <InfoCircleOutlined />,
          color: "#ffffff",
        }}

      >
        <TextArea  placeholder="แผนสร้างการซื้อซ้ำ (Repeat Plan)  วิธีทำให้ลูกค้ากลับมาซื้ออีก" showCount maxLength={5000}  rows={10} />
      </Form.Item>
    </FormWrapper>

  );
};

const TooltipContent = () => {
  return (
    <div style={{ width: "100%" }}>
      <h6 style={{ color: "black" }}>ตัวอย่าง "แผนสร้างการซื้อซ้ำ (Repeat Plan)"</h6>
      <p style={{ color: "black" }}>
        วิธีทำให้ลูกค้ากลับมาซื้ออีก กำหนดราคา สินค้ามีความแตกต่างกัน มีการจัดส่งสินค้า มีการส่งข้อมูลสินค้า มีการส่งข้อมูลการขาย มีการส่งข้อมูลการซื้อสินค้า
      </p>
    </div>
  );
};
export default ProductSGInviteSale;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
  margin-bottom: 10px;
`;
